import { render } from "./Login.vue?vue&type=template&id=2a31c4f2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "@/assets/css/argon-dashboard.css?vue&type=style&index=0&id=2a31c4f2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a31c4f2"]])

export default __exports__